import { useState } from "react";
import { Button, Tag } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { ListPage } from "../../components/ListPage";
import { BoatFormModal } from "../../components/BoatFormModal";
import { hasPermission } from "../../helpers/permissions";
import { useUser } from "../../context/UserContext";
import type { Boat } from "../../api-models";

// The vessel register behind Boat Notes. A boat is retired, never deleted — issued
// manifests still point at it (boats.go).
export default function BoatsPage() {
  const { user } = useUser();
  const canWrite = hasPermission(user, "Boats.Write");
  const [editing, setEditing] = useState<Boat | null>(null);
  const [open, setOpen] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  function openModal(boat: Boat | null) {
    setEditing(boat);
    setOpen(true);
  }

  return (
    <>
      <ListPage<Boat>
        key={reloadKey}
        title="Boats"
        endpoint="/boats"
        searchPlaceholder="Search boats..."
        actions={
          canWrite && (
            <Button type="primary" icon={<PlusOutlined />} onClick={() => openModal(null)}>
              New boat
            </Button>
          )
        }
        columns={[
          { title: "Name", dataIndex: "name", sorter: true },
          { title: "Contact", dataIndex: "contact", sorter: true },
          { title: "Notes", dataIndex: "notes" },
          {
            title: "Status",
            dataIndex: "active",
            sorter: true,
            render: (v) => <Tag color={v ? "green" : "default"}>{v ? "In service" : "Retired"}</Tag>,
          },
          ...(canWrite
            ? [
                {
                  title: "",
                  key: "edit",
                  render: (_: unknown, r: Boat) => (
                    <Button type="link" onClick={() => openModal(r)}>
                      Edit
                    </Button>
                  ),
                },
              ]
            : []),
        ]}
      />
      <BoatFormModal
        open={open}
        boat={editing}
        onCancel={() => setOpen(false)}
        onSaved={() => {
          setOpen(false);
          setReloadKey((k) => k + 1);
        }}
      />
    </>
  );
}
